module.exports = __webpack_public_path__ + "img/pdf.b0db7969.png";